import { Alert, Box } from '@mui/material'
import { useHistory } from 'react-router-dom'
import WhatsappPageHeader from '../../components/whatsapp/WhatsappPageHeader'
import AutomationTable from '../../components/whatsapp/AutomationTable'

export default function WhatsappAutomationPage() {
  const history = useHistory()

  const goToParams = () => {
    history.push('/business/whatsapp/params')
  }
  return (
    <Box className="page-content">
      <WhatsappPageHeader activeTab="automation" />
      <Alert severity="info" sx={{ my: 1 }}>
        Automations help you answer queries from your customers and send automatic notifications when the status of an order changes. You must create the necessary templates for each automation on Meta Business - Whatsapp Manager. Use
        {' '}
        <u style={{ cursor: 'pointer' }} onClick={goToParams}><b>sokolink parameters</b></u>
        {' '}
        to make the templates dynamic.
      </Alert>
      <AutomationTable />
    </Box>
  )
}
